import { PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029 } from "@faire/web-api/indigofair/settings/PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingPersistQuickAddOnSearchTile = () =>
  useSetting(PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029, false);

export const useAssignSettingPersistQuickAddOnSearchTile = () =>
  useAssignSetting(PERSIST_QUICK_ADD_ON_SEARCH_TILE_241029);
